export default {
  feedbackReports: {
    tab: 'Feedback',
    title: 'Kursfeedback',
    subtitle: 'Eingereichtes Feedback für die ausgewählten Kurse und Zeiträume anzeigen.',
    allCourses: 'Alle Kurse',
    from: 'Von (UTC)',
    to: 'Bis (UTC)',
    apply: 'Filter anwenden',
    dateError: 'Das Startdatum darf nicht nach dem Enddatum liegen.',
    exportHint: 'Exportiert alle gefilterten Antworten mit einer Zeile pro Frage. Bis zu 10.000 Rückmeldungen pro Export.',
    exportLimit: 'Mehr als 10.000 Rückmeldungen entsprechen diesen Filtern. Wählen Sie einen Kurs oder einen kürzeren Zeitraum für den Export.',
    empty: 'Kein Feedback gefunden',
    emptyHint: 'Für diese Filter wurde noch kein Feedback eingereicht.',
    responseCount: 'Rückmeldungen',
    average: 'Durchschnittliche Hilfreichkeit',
    ratedCount: 'Basierend auf {count} Bewertungen',
    version: 'Fragebogenversion {version} · {count} Rückmeldungen',
    answered: '{count} von {total} haben geantwortet',
    multipleHint: 'Mehrfachauswahl möglich. Prozentwerte beziehen sich auf die Personen, die diese Frage beantwortet haben.',
    responses: 'Einzelne Rückmeldungen',
    submitted: 'Eingereicht (UTC)',
    helpfulness: 'Hilfreichkeit',
    answers: 'Antworten',
    view: 'Antworten anzeigen',
    previous: 'Zurück',
    next: 'Weiter',
    page: 'Seite {page} von {total}',
    responseFrom: 'Feedback von {name}',
    responseVersion: 'Kursversion {course} · Fragebogenversion {questionnaire}',
    unanswered: 'Nicht beantwortet',
    close: 'Antworten schließen',
  },
  courseFeedback: {
    tab: 'Kursfeedback',
    navigationLocked: 'Bitte füllen Sie zuerst das Feedbackformular aus und senden Sie es ab.',
    submitCertificate: 'Feedback senden und Zertifikat ansehen',
    submitCourses: 'Feedback senden und zurück zu den Kursen',
    submitJourney: 'Feedback senden und Lernpfad fortsetzen',
    backToJourney: 'Zurück zum Lernpfad',
    readOnly: 'Dies sind Ihre bereits gesendeten Antworten zu diesem Kurs.',
    notAnswered: 'Nicht beantwortet',
    eyebrow: 'Kurs abgeschlossen',
    completeTitle: 'Geschafft! Sie haben den Kurs abgeschlossen.',
    title: 'Wie war Ihr Kurs?',
    intro: 'Ihr Feedback hilft uns, unsere Kurse zu verbessern. Ein paar Klicks genügen.',
    required: 'Pflichtfeld',
    optional: 'Optional',
    multiple: 'Mehrfachauswahl möglich.',
    thanks: 'Vielen Dank für Ihr Feedback!',
    saved: 'Ihre Antworten zu diesem Kurs wurden gespeichert.',
    loading: 'Feedback wird geladen…',
    loadError:
      'Das Feedback konnte nicht geladen werden. Ihr Kurs ist abgeschlossen. Bitte versuchen Sie es erneut.',
    retry: 'Erneut versuchen',
    saveError:
      'Ihr Feedback konnte nicht gespeichert werden. Ihre Auswahl bleibt erhalten. Bitte senden Sie es erneut.',
    submit: 'Feedback senden',
    completionSaved: 'Ihr Kursabschluss ist bereits gespeichert.',
    certificate: 'Zertifikat ansehen',
    backToCourses: 'Zurück zu den Kursen',
  },
  common: {
    appName: 'Reybex Academy',
    save: 'Speichern',
    saving: 'Wird gespeichert…',
    saved: 'Gespeichert',
    cancel: 'Abbrechen',
    close: 'Schließen',
    delete: 'Löschen',
    remove: 'Entfernen',
    edit: 'Bearbeiten',
    create: 'Erstellen',
    add: 'Hinzufügen',
    back: 'Zurück',
    next: 'Weiter',
    previous: 'Zurück',
    search: 'Suchen',
    searchPlaceholder: 'Suchen…',
    filter: 'Filtern',
    clear: 'Zurücksetzen',
    clearFilters: 'Filter zurücksetzen',
    all: 'Alle',
    none: 'Keine',
    yes: 'Ja',
    no: 'Nein',
    optional: 'Optional',
    required: 'Erforderlich',
    loading: 'Wird geladen…',
    retry: 'Erneut versuchen',
    confirm: 'Bestätigen',
    actions: 'Aktionen',
    status: 'Status',
    title: 'Titel',
    description: 'Beschreibung',
    duration: 'Dauer',
    points: 'Punkte',
    pointsLabel: 'Punkte',
    progress: 'Fortschritt',
    minutes: '{count} Min.',
    hours: '{count} Std.',
    of: 'von',
    showing: '{from}–{to} von {total}',
    page: 'Seite {page}',
    unknown: 'Unbekannt',
    never: 'Nie',
    today: 'Heute',
    dueOn: 'Fällig am {date}',
    overdue: 'Überfällig',
    notSet: 'Nicht gesetzt',
    copy: 'Kopieren',
    copied: 'Kopiert',
    copyLink: 'Öffentlichen Link kopieren',
    linkCopied: 'Link kopiert.',
    download: 'Herunterladen',
    preview: 'Vorschau',
    publish: 'Veröffentlichen',
    unpublish: 'Veröffentlichung zurückziehen',
    archive: 'Archivieren',
    restore: 'Wiederherstellen',
    signOut: 'Abmelden',
    profile: 'Profil',
    language: 'Sprache',
    theme: 'Design',
    learner: 'Lernender',
    instructor: 'Trainer',
    admin: 'Administrator',
  },

  nav: {
    dashboard: 'Übersicht',
    courses: 'Kurse',
    journeys: 'Lernpfade',
    certificates: 'Zertifikate',
    profile: 'Profil',
    adminArea: 'Verwaltung',
    adminDashboard: 'Kurse',
    adminCourses: 'Kurse',
    adminJourneys: 'Lernpfade',
    adminUsers: 'Benutzer',
    adminReports: 'Berichte',
    adminSettings: 'Einstellungen',
    backToLearning: 'Zur Übersicht zurück',
    openMenu: 'Navigation öffnen',
    closeMenu: 'Navigation schließen',
    skipToContent: 'Zum Inhalt springen',
    signInRequired: 'Anmeldung erforderlich',
  },

  auth: {
    loginTitle: 'Anmelden',
    loginSubtitle: 'Lernen Sie weiter',
    reybexLoginSubtitle: 'Mit Ihrem Reybex-Benutzernamen und Passwort anmelden',
    lmsAccount: 'LMS-Konto',
    reybexAccount: 'Reybex-Konto',
    username: 'Benutzername',
    signInWithReybex: 'Mit Reybex anmelden',
    registerTitle: 'Konto erstellen',
    registerSubtitle: 'In wenigen Minuten mit dem Lernen beginnen',
    forgotTitle: 'Passwort zurücksetzen',
    forgotSubtitle: 'Wir senden Ihnen einen Link per E-Mail',
    resetTitle: 'Neues Passwort wählen',
    email: 'E-Mail',
    password: 'Passwort',
    confirmPassword: 'Passwort Bestätigen',
    fullName: 'Vollständiger Name',
    signIn: 'Anmelden',
    signUp: 'Konto erstellen',
    sendResetLink: 'Link senden',
    updatePassword: 'Passwort Aktualisieren',
    noAccount: 'Noch kein Konto?',
    haveAccount: 'Sie haben bereits ein Konto?',
    forgotPassword: 'Passwort vergessen?',
    backToLogin: 'Zurück zur Anmeldung',
    landingPage: 'Startseite',
    continueAsGuest: 'Ohne Anmeldung fortfahren',
    resetLinkSent: 'Prüfen Sie Ihr Postfach auf den Link zum Zurücksetzen.',
    passwordUpdated: 'Ihr Passwort wurde aktualisiert.',
    registrationComplete: 'Ihr Konto wurde erstellt. Melden Sie sich an, um fortzufahren.',
    signedOut: 'Sie wurden abgemeldet.',
    accountDeactivated:
      'Dieses Konto wurde deaktiviert. Wenden Sie sich an eine Administratorin oder einen Administrator.',
    sessionExpired: 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',
    showPassword: 'Passwort anzeigen',
    hidePassword: 'Passwort verbergen',
    profile: 'Ihr Profil',
    profileSubtitle: 'Ihre Angaben und das Verhalten der Plattform für Sie.',
    reybexDetails: {
      partnerAccount: 'Partnerkonto',
      title: 'Reybex-Kontodaten',
      tenantId: 'Mandanten-ID',
      username: 'Benutzername',
      email: 'E-Mail',
      phone: 'Telefon',
      mobile: 'Mobiltelefon',
      language: 'Sprache',
      timezone: 'Zeitzone',
      position: 'Position',
      signInAgain:
        'Melden Sie sich ab und erneut mit Ihrem Reybex-Konto an, um Ihre Daten zu laden.',
    },
    accountDetails: 'Kontodaten',
    academyAccountDetails: 'Academy-Kontodaten',
    timezone: 'Zeitzone',
    changePassword: 'Passwort Ändern',
    newPassword: 'Neues Passwort',
    passwordHint: 'Mindestens 8 Zeichen.',
    passwordManagedByReybex: 'Das Passwort dieses Kontos wird in Reybex verwaltet.',
    memberSince: 'Mitglied seit {date}',
    profileSaved: 'Ihr Profil wurde gespeichert.',
  },

  dashboard: {
    greeting: 'Hallo, {name}',
    learnerSubtitle: 'Hier haben Sie zuletzt aufgehört.',
    adminTitle: 'Kurskatalog',
    adminSubtitle: 'Kurse anlegen, Lektionen und Tests hinzufügen, dann veröffentlichen.',
    defineCourses: 'Ihre Kurse',
    defineCoursesHint: 'Legen Sie einen Kurs an, um Inhalte zu definieren.',
    newCourseHint: 'Ein Titel reicht. Den Rest füllen Sie im Editor aus.',
    noCoursesYet: 'Noch keine Kurse',
    claimAdminBanner:
      'Diese Installation hat noch keinen Administrator. Übernehmen Sie die Rolle, um Kurse anzulegen.',
    claimAdminAction: 'Admin-Einrichtung öffnen',
    totalPoints: 'Punkte insgesamt',
    inProgress: 'In Bearbeitung',
    completed: 'Abgeschlossen',
    notStarted: 'Nicht begonnen',
    certificates: 'Zertifikate',
    averageProgress: 'Durchschnittlicher Fortschritt',
    continueLearning: 'Weiterlernen',
    recentCourses: 'Zuletzt geöffnet',
    assignedCourses: 'Ihnen zugewiesen',
    recommended: 'Empfehlungen für Sie',
    journeyProgress: 'Ihre Lernpfade',
    upcomingDeadlines: 'Anstehende Fristen',
    achievements: 'Erfolge',
    noDeadlines: 'Keine anstehenden Fristen.',
    noAchievements: 'Schließen Sie einen Kurs ab, um Ihren ersten Erfolg zu erhalten.',
    achievementsInvite:
      'Schließen Sie einen Kurs ab, holen Sie ein Zertifikat oder beenden Sie einen Lernpfad.',
    totalUsers: 'Benutzer',
    activeLearners: 'Aktive Lernende (30 Tage)',
    totalCourses: 'Kurse',
    completionRate: 'Abschlussquote',
    quizPerformance: 'Durchschnittliche Testpunktzahl',
    quizPassRate: 'Bestehensquote',
    popularCourses: 'Beliebteste Kurse',
    recentRegistrations: 'Neue Registrierungen',
    recentCompletions: 'Letzte Abschlüsse',
    overdueAssignments: 'Überfällige Zuweisungen',
    certificatesIssued: 'Ausgestellte Zertifikate',
    enrollments: 'Einschreibungen',
  },

  onboarding: {
    suggested: 'Vorgeschlagene Kurse',
    personalize: 'Personalisieren',
    emptyHint: 'Wählen Sie Ihren Bereich, um passende Kurse zu sehen.',
    welcomeTitle: 'Willkommen bei Reybex Campus',
    welcomeBody: 'Personalisieren Sie Ihr Lernen in weniger als einer Minute.',
    start: 'Einrichtung starten',
    skip: 'Vorerst überspringen',
    back: 'Zurück',
    next: 'Weiter',
    finish: 'Fertig',
    stepOf: 'Frage {current} von {total}',
    roleTitle: 'Was beschreibt Ihre Arbeit am besten?',
    roleMulti: 'Sie können mehrere auswählen.',
    levelTitle: 'Wie erfahren sind Sie mit reybex?',
    focusTitle: 'Worauf möchten Sie sich zuerst konzentrieren?',
    focusOptional: 'Diesen Schritt können Sie überspringen.',
    doneTitle: 'Fertig',
    doneBody: 'Vorschläge folgen jetzt den gewählten Bereichen.',
    role: {
      sales: 'Vertrieb',
      salesBody: 'Angebote, Kunden und Vertriebsprozesse.',
      warehouse: 'Lager',
      warehouseBody: 'Bestand, Kommissionierung und Versand.',
      purchasing: 'Einkauf',
      purchasingBody: 'Lieferanten und Beschaffung.',
      production: 'Produktion',
      productionBody: 'Fertigung und Werkstattabläufe.',
      finance: 'Finanzen',
      financeBody: 'Rechnungen, Zahlungen und Berichte.',
      ecommerce: 'E-Commerce',
      ecommerceBody: 'Shop, Bestellungen und Online-Verkauf.',
      developer: 'Technik',
      developerBody: 'Einrichtung, APIs und Erweiterungen.',
      partner: 'Partner',
      partnerBody: 'Schulung für externe Partner.',
    },
    level: {
      new: 'Neu bei reybex',
      basic: 'Grundkenntnisse',
      intermediate: 'Fortgeschritten',
      advanced: 'Experte',
    },
    focus: {
      quick: 'Schneller Einstieg',
      role: 'Rollenspezifische Schulung',
      certificates: 'Zertifikate',
      advanced: 'Erweiterte Prozesse',
    },
    none: 'In diesem Bereich gibt es noch keine Kurse.',
  },

  courses: {
    title: 'Kurse',
    subtitle: 'Sehen Sie sich das Angebot an und machen Sie dort weiter, wo Sie aufgehört haben.',
    myCourses: 'Meine Kurse',
    catalog: 'Katalog',
    allCourses: 'Alle Kurse',
    enroll: 'Einschreiben',
    signInToEnroll: 'Zum Einschreiben anmelden',
    enrolling: 'Wird eingeschrieben…',
    enrolled: 'Eingeschrieben',
    start: 'Kurs starten',
    continue: 'Fortsetzen',
    review: 'Ansehen',
    retakeQuiz: 'Test wiederholen',
    takeQuiz: 'Zum Test',
    viewCourse: 'Ansehen',
    lessons: '{count} Lektionen',
    lessonsLabel: 'Lektionen',
    lessonsCompleted: '{done} von {total} Lektionen',
    category: 'Kategorie',
    difficulty: 'Niveau',
    instructor: 'Trainer',
    language: 'Sprache',
    objectives: 'Das lernen Sie',
    prerequisites: 'Voraussetzungen',
    courseContent: 'Kursinhalt',
    aboutCourse: 'Über diesen Kurs',
    estimatedDuration: 'Geschätzte Dauer',
    certificateAvailable: 'Zertifikat bei Abschluss',
    pointsOnCompletion: '{points} Punkte bei Abschluss',
    quizRequired: 'Zum Abschluss dieses Kurses müssen Sie den Abschlusstest bestehen.',
    difficultyBeginner: 'Einsteiger',
    difficultyIntermediate: 'Mittel',
    difficultyAdvanced: 'Fortgeschritten',
    visibilityPrivate: 'Privat',
    visibilityPublic: 'Öffentlich',
    statusDraft: 'Entwurf',
    statusPublished: 'Veröffentlicht',
    statusArchived: 'Archiviert',
    state: {
      not_started: 'Nicht begonnen',
      in_progress: 'In Bearbeitung',
      quiz_pending: 'Test offen',
      quiz_failed: 'Test nicht bestanden',
      completed: 'Abgeschlossen',
    },
    stateHint: {
      not_started: 'Sie haben diesen Kurs noch nicht begonnen.',
      in_progress: 'Weiter so — einige erforderliche Lektionen sind noch offen.',
      quiz_pending: 'Alle Lektionen sind erledigt. Bestehen Sie den Test, um abzuschließen.',
      quiz_failed:
        'Sie haben die erforderliche Punktzahl nicht erreicht. Sehen Sie sich die Lektionen noch einmal an.',
      completed: 'Sie haben diesen Kurs abgeschlossen.',
    },
    empty: 'Noch keine Kurse vorhanden.',
    emptyEnrolled: 'Sie sind noch in keinem Kurs eingeschrieben.',
    emptyCatalog: 'Es wurde noch nichts veröffentlicht. Schauen Sie später wieder vorbei.',
    archivedNotice:
      'Dieser Kurs ist archiviert. Sie können ihn ansehen, aber nicht mehr neu starten.',
    unpublishedNotice:
      'Dieser Kurs ist nicht mehr veröffentlicht. Ihr Zugang bleibt bestehen, weil Sie bereits eingeschrieben waren.',
  },

  player: {
    courseContent: 'Kursinhalt',
    lesson: 'Lektion',
    quiz: 'Test',
    markComplete: 'Als abgeschlossen markieren',
    markingComplete: 'Wird gespeichert…',
    completed: 'Abgeschlossen',
    nextLesson: 'Nächste Lektion',
    previousLesson: 'Vorherige Lektion',
    resources: 'Downloads',
    transcript: 'Transkript',
    noResources: 'Für diese Lektion gibt es keine Downloads.',
    progressLabel: '{percent}% abgeschlossen',
    lessonCompletedToast: 'Lektion abgeschlossen',
    allLessonsDone: 'Alle Lektionen sind abgeschlossen.',
    quizPendingBanner:
      'Sie haben alle erforderlichen Lektionen abgeschlossen. Der Test ist der letzte Schritt.',
    quizFailedBanner:
      'Ihr letzter Versuch war nicht erfolgreich. Sehen Sie sich das Material an und versuchen Sie es erneut.',
    courseCompleteBanner: 'Kurs abgeschlossen. Punkte und Zertifikat sind bereit.',
    courseCompleteShort: 'Kurs abgeschlossen.',
    quizLockedByLessons:
      'Schließen Sie alle erforderlichen Lektionen ab, um den Test freizuschalten.',
    resumeNotice: 'Dort fortgesetzt, wo Sie aufgehört haben.',
    videoUnavailable: 'Dieses Video kann derzeit nicht abgespielt werden.',
    videoUnavailableHint:
      'Die Datei konnte nicht geladen werden. Versuchen Sie es erneut oder fahren Sie mit einer anderen Lektion fort.',
    videoMissingSource: 'Dieser Lektion wurde noch keine Videodatei zugeordnet.',
    reportProblem: 'Problem melden',
    problemReported: 'Danke — eine Administratorin oder ein Administrator wurde informiert.',
    offline:
      'Sie sind offline. Ihr Fortschritt wird gespeichert, sobald die Verbindung zurück ist.',
    backToCourse: 'Kursübersicht',
    requiredLesson: 'Erforderlich',
    optionalLesson: 'Optional',
    journeyContext: 'Teil von {journey}',
    nextInJourney: 'Als Nächstes in diesem Lernpfad',
    exitPlayer: 'Player verlassen',
    lessonList: 'Lektionen',
    pauseNudge: 'Weiter — noch {percent} % bis zum Abschluss dieser Lektion.',
    watchRing: '{watched} % gesehen. Abschluss bei {threshold} %.',
    requirementsChanged:
      'Dieser Kurs wurde aktualisiert und enthält jetzt weitere erforderliche Lektionen.',
  },

  quiz: {
    title: 'Test',
    start: 'Test starten',
    starting: 'Wird gestartet…',
    resume: 'Test fortsetzen',
    submit: 'Antworten abgeben',
    submitting: 'Wird abgegeben…',
    question: 'Frage {current} von {total}',
    passingScore: 'Bestehensgrenze: {score}%',
    timeLimit: 'Zeitlimit: {minutes} Min.',
    noTimeLimit: 'Kein Zeitlimit',
    attemptsLeft: 'Noch {count} Versuche',
    attemptsUnlimited: 'Unbegrenzte Versuche',
    attemptNumber: 'Versuch {number}',
    timeRemaining: 'Restzeit',
    timeUp: 'Die Zeit ist abgelaufen. Ihre Antworten wurden abgegeben.',
    selectOne: 'Wählen Sie eine Antwort',
    selectMultiple: 'Wählen Sie alle zutreffenden Antworten',
    trueLabel: 'Richtig',
    falseLabel: 'Falsch',
    unanswered: '{count} unbeantwortet',
    confirmSubmitTitle: 'Antworten abgeben?',
    confirmSubmitBody:
      'Es sind {count} Fragen unbeantwortet. Bei einer Abgabe jetzt werden sie als falsch gewertet.',
    confirmSubmitAll: 'Trotzdem abgeben',
    resultPassed: 'Bestanden',
    resultFailed: 'Nicht bestanden',
    certificateUnlocked: 'Sie haben das Kurszertifikat erhalten.',
    redirectingToCertificate: 'Sie werden zu Ihrem Zertifikat weitergeleitet…',
    yourScore: 'Ihr Ergebnis',
    scoreOf: '{score}% (Bestehensgrenze {passing}%)',
    reviewAnswers: 'Antworten ansehen',
    continueToFeedback: 'Weiter zum Kursfeedback',
    backToResults: 'Zurück zum Testergebnis',
    reviewLoadError:
      'Ihr Ergebnis ist gespeichert, aber die Antwortübersicht konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
    correct: 'Richtig',
    incorrect: 'Falsch',
    explanation: 'Erläuterung',
    attemptHistory: 'Frühere Versuche',
    noAttempts: 'Noch keine Versuche.',
    maxAttemptsReached:
      'Sie haben alle {count} Versuche genutzt. Wenden Sie sich an die Administration, wenn Sie einen weiteren benötigen.',
    retake: 'Erneut versuchen',
    backToCourse: 'Zurück zum Kurs',
    expiredNotice: 'Dieser Versuch wurde nach dem Zeitlimit abgegeben und unverändert bewertet.',
    invalidatedNotice:
      'Der Test wurde während Ihres Versuchs geändert und daher verworfen. Sie können ohne Verlust neu beginnen.',
    draftRestored: 'Ihre bereits gewählten Antworten wurden wiederhergestellt.',
    submitFailedRetrying: 'Abgabe fehlgeschlagen. Neuer Versuch…',
    submitFailed:
      'Wir konnten Ihre Antworten nicht abgeben. Prüfen Sie die Verbindung und versuchen Sie es erneut.',
  },

  journeys: {
    title: 'Lernpfade',
    subtitle: 'Strukturierte Pfade aus mehreren Kursen.',
    start: 'Lernpfad starten',
    signUpToStart: 'Konto erstellen, um zu starten',
    continue: 'Lernpfad fortsetzen',
    leave: 'Lernpfad verlassen',
    leaveConfirmTitle: 'Diesen Lernpfad verlassen?',
    leaveConfirmBody:
      'Ihr Kursfortschritt bleibt erhalten. Sie können später wieder einsteigen und weitermachen.',
    rejoin: 'Wieder einsteigen',
    courses: 'Kurse in diesem Lernpfad',
    courseCount: '{count} Kurse',
    modeSequential: 'Der Reihe nach',
    modeFlexible: 'Flexibel',
    modeSequentialHint:
      'Erforderliche Kurse müssen in der vorgegebenen Reihenfolge abgeschlossen werden.',
    modeFlexibleHint: 'Erforderliche Kurse können in beliebiger Reihenfolge abgeschlossen werden.',
    locked: 'Gesperrt',
    lockedHint: 'Schließen Sie den vorherigen erforderlichen Kurs ab, um diesen freizuschalten.',
    completedCourses: 'Abgeschlossen',
    remainingCourses: 'Offen',
    state: {
      not_started: 'Nicht begonnen',
      in_progress: 'In Bearbeitung',
      completed: 'Abgeschlossen',
      abandoned: 'Verlassen',
    },
    empty: 'Es wurden noch keine Lernpfade veröffentlicht.',
    completedBanner: 'Lernpfad abgeschlossen. Ihr Zertifikat ist bereit.',
    objectives: 'Inhalte dieses Lernpfads',
  },

  certificates: {
    title: 'Zertifikate',
    subtitle: 'Alles, was Sie erreicht haben.',
    certificateNumber: 'Zertifikatsnummer',
    issuedOn: 'Ausgestellt am',
    expiresOn: 'Gültig bis',
    noExpiry: 'Unbegrenzt gültig',
    learner: 'Ausgestellt für',
    course: 'Kurs',
    journey: 'Lernpfad',
    downloadPdf: 'PDF herunterladen',
    generating: 'Wird vorbereitet…',
    verify: 'Prüfen',
    verifyTitle: 'Zertifikatsprüfung',
    verifySubtitle: 'Prüfen Sie, ob ein Zertifikat echt ist.',
    verifyLinkCopied: 'Prüflink kopiert.',
    copyVerifyLink: 'Prüflink kopieren',
    empty: 'Sie haben noch keine Zertifikate. Schließen Sie einen Kurs ab, um eines zu erhalten.',
    justEarned: 'Glückwunsch — Ihr Zertifikat ist bereit.',
    statusActive: 'Gültig',
    statusRevoked: 'Widerrufen',
    statusExpired: 'Abgelaufen',
    notFound: 'Zu diesem Prüflink gibt es kein Zertifikat.',
    verifiedValid: 'Dieses Zertifikat ist gültig.',
    verifiedRevoked: 'Dieses Zertifikat wurde am {date} widerrufen.',
    verifiedExpired: 'Dieses Zertifikat ist am {date} abgelaufen.',
    issuedBy: 'Ausgestellt von',
    revoke: 'Widerrufen',
    revokeTitle: 'Dieses Zertifikat widerrufen?',
    revokeBody:
      'Das Zertifikat gilt ab sofort als ungültig. Bereits erhaltene Punkte bleiben bestehen.',
    revokeReason: 'Grund',
    revoked: 'Zertifikat widerrufen.',
    certificateOfCompletion: 'Abschlusszertifikat',
    hasCompleted: 'hat erfolgreich abgeschlossen',
    certificateEyebrow: 'Zertifikat',
    certifiesThat: 'Hiermit wird bestätigt, dass',
    hasCompletedProgram: 'die folgende Weiterbildung erfolgreich abgeschlossen hat',
    validUntil: 'Gültig bis {date}',
    verifyAt: 'Zertifikat prüfen unter',
    preview: 'Zertifikat ansehen',
  },

  admin: {
    coursesTitle: 'Kurse',
    coursesSubtitle: 'Kursinhalte erstellen und verwalten.',
    newCourse: 'Neuer Kurs',
    editCourse: 'Kurs bearbeiten',
    courseCreated: 'Kurs erstellt.',
    courseUpdated: 'Kurs gespeichert.',
    courseDeleted: 'Kurs gelöscht.',
    coursePublished: 'Kurs veröffentlicht.',
    courseUnpublished: 'Kurs zurück in den Entwurf verschoben.',
    courseArchived: 'Kurs archiviert.',
    deleteCourseTitle: 'Diesen Kurs löschen?',
    deleteCourseBody:
      'Das kann nicht zurückgenommen werden. Archivieren Sie den Kurs, wenn Lernende ihn genutzt haben.',
    tabDetails: 'Details',
    tabContent: 'Inhalt',
    tabQuiz: 'Test',
    tabCompletion: 'Abschluss',
    tabPublish: 'Veröffentlichen',
    slug: 'URL-Kürzel',
    slugHint: 'Wird in der Kursadresse verwendet. Aus dem Titel erzeugt.',
    shortDescription: 'Kurzbeschreibung',
    shortDescriptionHint: 'Eine Zeile, die auf Kurskarten erscheint.',
    documentEditorHint:
      'Schreiben Sie den Kurs wie ein Dokument: Überschriften, Listen, Bilder, YouTube und HTTPS-Iframes. Der Inhalt wird vor der Anzeige bereinigt.',
    documentEditorPlaceholder:
      'Beschreiben Sie den Kurs, fügen Sie Beispiele ein, betten Sie eine Demo ein…',
    insertLink: 'Link',
    insertImage: 'Bild',
    insertYoutube: 'YouTube',
    insertIframe: 'Iframe',
    insertImagePrompt: 'Bild-URL (https://)',
    insertYoutubePrompt: 'YouTube-URL',
    insertIframePrompt: 'Embed-URL (https:// iframe src)',
    thumbnail: 'Titelbild',
    thumbnailHint:
      'Erscheint auf Kurs- und Lernpfadkarten. Wählen Sie eines der Academy-Titelbilder.',
    thumbnailLibrary: 'Titelbild wählen',
    chooseThumbnail: 'Titelbild wählen',
    clearThumbnail: 'Titelbild entfernen',
    durationFromLessons: 'Wird aus den Minuten der Lektionen in diesem Kurs berechnet.',
    durationFromCourses: 'Wird aus den Dauern der Kurse in diesem Lernpfad berechnet.',
    courseIllustration: 'Kursillustration',
    courseIllustrationHint: 'Das ist die visuelle Identität des Kurses im Katalog.',
    courseIllustrationLibrary: 'Kursbild wählen',
    chooseIllustration: 'Bild wählen',
    illustrationCovers: 'Titelbilder',
    illustrationModules: 'Produktbilder',
    illustrationDrawings: 'Illustrationen',
    illustrationPhotos: 'Fotos',
    illustrations: {
      moduleAdministration: 'Administration',
      moduleAllgemein: 'Allgemein',
      moduleArtikelPim: 'Artikel / PIM',
      moduleCrm: 'CRM',
      moduleCrmPhoto: 'CRM',
      moduleEcommerce: 'E-Commerce',
      moduleEinkauf: 'Einkauf',
      moduleEntwicklung: 'Entwicklung',
      moduleFinanzen: 'Finanzen',
      moduleKassePos: 'Kasse / POS',
      moduleMobileLager: 'Mobile Lager-App',
      moduleVerkauf: 'Verkauf',
      moduleVersand: 'Versand',
      erp: 'ERP / Unternehmen',
      cloud: 'Cloud-ERP',
      dashboard: 'Business-Dashboard',
      sales: 'Vertrieb',
      purchasing: 'Einkauf',
      warehouse: 'Lager',
      inventory: 'Bestand',
      products: 'Produkte',
      crm: 'CRM',
      production: 'Produktion',
      supplyChain: 'Lieferkette',
      finance: 'Finanzen',
      invoice: 'Rechnung',
      documents: 'Dokumente',
      workflow: 'Workflow',
      automation: 'Automatisierung',
      ai: 'KI-Assistent',
      integration: 'Integration',
      users: 'Benutzer und Rollen',
      analytics: 'Analysen',
      photoOperations: 'Geschäftsabläufe',
      photoCloud: 'Rechenzentrum',
      photoWarehouse: 'Lagerhalle',
      photoFulfillment: 'Auftragsabwicklung',
      photoFinance: 'Finanzdaten',
      photoLogistics: 'Logistik',
      photoTeam: 'Team',
      photoAnalytics: 'Analysebildschirm',
      photoServers: 'Server',
      photoFactory: 'Fertigung',
    },
    cover: 'Titelbild',
    tags: 'Schlagwörter',
    tagsHint: 'Mit Enter hinzufügen.',
    objectives: 'Lernziele',
    prerequisites: 'Voraussetzungen',
    estimatedDuration: 'Geschätzte Dauer (Minuten)',
    visibility: 'Sichtbarkeit',
    visibilityHint:
      'Öffentlich und veröffentlicht ohne Gruppen: Jeder mit dem Link kann ansehen (ohne Quiz und Fortschritt). Gruppen beschränken, wer sich einschreiben darf. Bei ausgewählten Gruppen erscheinen öffentliche, veröffentlichte Inhalte nur im Katalog von Nutzern, die mindestens einer ausgewählten Gruppe angehören.',
    groups: 'Gruppen',
    courseGroupsLabel: 'Gruppen (Wer kann sich einschreiben)',
    courseGroupsHint:
      'Bei ausgewählten Gruppen können nur Mitglieder mindestens einer dieser Gruppen den Kurs ansehen und sich selbst einschreiben, auch bei privaten Kursen über einen Link. Ohne Gruppen: Bei öffentlichen Kursen ist die Selbsteinschreibung möglich; private Kurse erfordern eine Zuweisung. Unter Zugewiesene Lernende hinzugefügte Personen werden unabhängig von ihrer Gruppenzugehörigkeit eingeschrieben.',
    groupsHint:
      'Leer bei einem öffentlichen Eintrag: der Link ist offen. Leer bei einem privaten Eintrag: nur Personal und Zuweisungen. Gewählte Gruppen beschränken den Zugang auf diese Lernendentypen.',
    publicLinkHint:
      'Teilen Sie diesen Nur-Ansicht-Link. Quiz und Fortschritt erfordern eine Anmeldung.',
    guestPreview:
      'Sie sehen eine Vorschau. Melden Sie sich an, um Quizze zu machen und Fortschritt zu speichern.',
    guestPreviewAuthed:
      'Sie sehen eine Vorschau. Schreiben Sie sich ein, um Quizze zu machen und den Fortschritt zu speichern.',
    guestQuizLocked: 'Quizze erfordern ein Konto. Melden Sie sich an, um zu starten.',
    guestQuizEnroll:
      'Schreiben Sie sich ein, um dieses Quiz zu starten und den Fortschritt zu speichern.',
    openAsLearner: 'In meinem Konto öffnen',
    sections: 'Abschnitte',
    addSection: 'Abschnitt hinzufügen',
    sectionTitle: 'Titel des Abschnitts',
    noSections: 'Noch keine Abschnitte. Fügen Sie einen hinzu, um den Kurs aufzubauen.',
    addLesson: 'Lektion hinzufügen',
    lessonType: 'Art der Lektion',
    lessonTypeVideo: 'Video',
    lessonTypeText: 'Text',
    lessonTypeQuiz: 'Test',
    noLessons: 'In diesem Abschnitt gibt es noch keine Lektionen.',
    lessonRequired: 'Für den Abschluss Erforderlich',
    lessonSaved: 'Lektion gespeichert.',
    lessonDeleted: 'Lektion gelöscht.',
    lessonArchived: 'Lektion archiviert.',
    lessonArchivedHint:
      'Lernende haben Fortschritt in dieser Lektion, daher wurde sie archiviert statt gelöscht. Sie zählt nicht mehr für den Abschluss.',
    deleteLessonTitle: 'Diese Lektion löschen?',
    deleteLessonBody:
      'Der Fortschritt der Lernenden bleibt erhalten, die Lektion wird aber ausgeblendet.',
    deleteSectionBody: 'Lektionen in diesem Abschnitt werden entgruppiert, nicht gelöscht.',
    ungroupedLessons: 'Nicht gruppierte Lektionen',
    questionTypeSingle: 'Einzelauswahl',
    questionTypeMultiple: 'Mehrfachauswahl',
    questionTypeTrueFalse: 'Wahr / Falsch',
    settingsSaved: 'Einstellungen gespeichert.',
    defaultPoints: 'Standardpunkte für einen Neuen Kurs',
    assignTitle: 'Lernenden zuweisen',
    assignSubtitle:
      'Ausgewählte Lernende werden sofort eingeschrieben und sehen das Fälligkeitsdatum auf dem Dashboard.',
    tabAssignments: 'Zuweisungen',
    designTitle: 'UI-Bausteine',
    reorderSaved: 'Reihenfolge gespeichert.',
    moveUp: 'Nach oben',
    moveDown: 'Nach unten',
    dragLesson: 'Zum Verschieben ziehen',
    dragJourneyCourse: 'Zum Sortieren ziehen',
    dropLessonHere: 'Lektion hier ablegen',
    videoMetadata: 'Video',
    videoTitle: 'Videotitel',
    videoUrl: 'Externe Video-URL',
    videoUrlHint:
      'YouTube-, Guidde- oder anderen HTTPS-Embed-Link oder eine direkte Videodatei einfügen. Hier wird nichts hochgeladen.',
    videoPath: 'Externer Dateipfad',
    videoDuration: 'Dauer (Sekunden)',
    videoThumbnail: 'URL des Vorschaubilds',
    videoTranscript: 'Transkript',
    videoTranscriptHint:
      'Optional. Eine .txt-, .vtt- oder .srt-Datei hochladen. Lernende sehen sie unter dem Video.',
    uploadTranscript: 'Transkript hochladen',
    transcriptWrite: 'oder hier eingeben',
    transcriptPlaceholder: 'Transkript hier einfügen oder schreiben',
    replaceTranscript: 'Transkript ersetzen',
    transcriptAttached: 'Aktuelles Transkript ({count} Zeichen)',
    transcriptEmpty: 'Diese Datei enthält keinen Text.',
    videoStatus: 'Videostatus',
    uploadVideo: 'Video hochladen',
    uploadVideoHint:
      'Der Upload zum externen Dateiserver ist noch nicht angebunden. Die Auswahl einer Datei erfasst ihre Angaben und protokolliert die Anfrage.',
    selectedFile: 'Ausgewählte Datei',
    uploadRequested:
      'Upload angefragt. Die Anfrage wurde für die Dateiserver-Anbindung protokolliert.',
    textContent: 'Inhalt der Lektion',
    textContentHint:
      'Einfache Formatierung wird unterstützt. Inhalte werden vor der Anzeige bereinigt.',
    resources: 'Downloads',
    addResource: 'Download hinzufügen',
    completionTitle: 'Abschlussbedingungen',
    completionSubtitle: 'Was Lernende tun müssen, damit der Kurs als abgeschlossen gilt.',
    requiredLessons: 'Erforderliche Lektionen',
    requiredLessonsCount: '{count} von {total} Lektionen sind erforderlich',
    requiresQuiz: 'Bestandenen Test Verlangen',
    requiresQuizHint:
      'Ist dies aus, gilt der Kurs mit den erforderlichen Lektionen als abgeschlossen.',
    finalQuiz: 'Abschlusstest',
    passingScore: 'Bestehensgrenze (%)',
    coursePoints: 'Vergebene Punkte',
    certificateEnabled: 'Zertifikat Ausstellen',
    videoCompletePercent: 'Video Gilt als Gesehen ab (%)',
    publishTitle: 'Veröffentlichen',
    publishSubtitle: 'Prüfungen, die vor der Sichtbarkeit für Lernende erfüllt sein müssen.',
    publishCheckLessons: 'Mindestens eine erforderliche Lektion',
    publishCheckQuiz: 'Ein Abschlusstest mit mindestens einer Frage',
    publishCheckDescription: 'Eine Kurzbeschreibung',
    publishBlocked: 'Erledigen Sie die Punkte oben, bevor Sie veröffentlichen.',
    quizBuilderTitle: 'Test',
    quizBuilderSubtitle: 'Lernende sehen dies als letzten Punkt im Kurs.',
    createQuiz: 'Test erstellen',
    quizTitle: 'Titel des Tests',
    timeLimitMinutes: 'Zeitlimit (Minuten)',
    timeLimitHint: 'Leer lassen für kein Limit.',
    maxAttempts: 'Maximale Versuche',
    maxAttemptsHint: 'Leer lassen für unbegrenzte Versuche.',
    shuffleQuestions: 'Fragen Mischen',
    addQuestion: 'Frage hinzufügen',
    importQuestions: 'Fragen importieren',
    importPoints: 'Punkte pro Frage',
    importPointsInvalid: 'Geben Sie eine ganze Zahl von 1 bis 100 ein.',
    importQuestionsHint:
      'Einzelauswahlfragen einfügen. Entweder AIKEN (A. B. C. und danach ANSWER: B) oder jede Antwort in einer eigenen Zeile und die richtige mit ✓ markieren. Fragen mit einer Leerzeile trennen.',
    importQuestionsPlaceholder: 'Fragen im AIKEN- oder ✓-Format einfügen',
    importQuestionsAction: 'Importieren',
    importQuestionsSuccess: '{count} Fragen importiert.',
    importQuestionsEmpty: 'Fügen Sie mindestens eine Frage ein.',
    importQuestionsError: 'Frage {question}: {reason}',
    aikenUnrecognized: 'Dieser Block ist weder AIKEN- noch Häkchen-Format.',
    aikenNoAnswer: 'Ergänzen Sie ANSWER: X oder markieren Sie genau eine Antwort mit ✓.',
    aikenAnswerMismatch: 'ANSWER {answer} passt zu keiner Antwort.',
    aikenTooFewOptions: 'Mindestens zwei Antworten sind erforderlich.',
    aikenMultipleCorrect: 'Nur eine richtige Antwort ist erlaubt.',
    aikenDuplicateLetter: 'Der Buchstabe {letter} wird mehrfach verwendet.',
    aikenNoPrompt: 'Der Fragetext fehlt.',
    aikenAmbiguous: 'Verwenden Sie entweder ANSWER: X oder ein ✓, nicht beides.',
    aikenTooLong: 'Die Frage oder eine Antwort ist zu lang.',
    questionPrompt: 'Frage',
    questionType: 'Art',
    questionPoints: 'Punkte',
    questionExplanation: 'Erläuterung nach der Abgabe',
    addOption: 'Antwortoption hinzufügen',
    optionLabel: 'Richtige Antwort',
    markCorrect: 'Richtig',
    noQuestions: 'Noch keine Fragen.',
    quizSaved: 'Test gespeichert.',
    quizNeedsCorrectOption: 'Jede Frage braucht mindestens eine richtige Antwort.',
    quizEditWarning:
      'Dieser Test wurde bereits bearbeitet. Strukturelle Änderungen verwerfen offene Versuche; abgegebene Versuche behalten ihr Ergebnis.',
    journeysTitle: 'Lernpfade',
    journeysSubtitle: 'Kurse zu einem strukturierten Pfad verbinden.',
    newJourney: 'Neuer Lernpfad',
    editJourney: 'Lernpfad bearbeiten',
    journeySaved: 'Lernpfad gespeichert.',
    journeyMode: 'Reihenfolge',
    journeyCourses: 'Kurse',
    filterByJourney: 'Lernpfad',
    allJourneys: 'Alle Lernpfade',
    filterContainsCourse: 'Enthält Kurs',
    allCourses: 'Alle Kurse',
    backToJourney: 'Zurück zum Lernpfad',
    backToCourses: 'Zurück zu den Kursen',
    addCourseToJourney: 'Kurs hinzufügen',
    addExistingCourse: 'Vorhandener Kurs',
    addExistingCourseHint: 'Wählen Sie einen Kurs, der schon im Katalog steht.',
    createCourseForJourney: 'Neuer Kurs',
    createCourseForJourneyHint:
      'Legt einen Entwurf mit Titel an und fügt ihn sofort diesem Lernpfad hinzu. Lektionen ergänzen Sie im Kurseditor.',
    createAndAddToJourney: 'Anlegen und hinzufügen',
    noCatalogCoursesLeft: 'Alle verfügbaren Kurse sind bereits auf diesem Lernpfad.',
    courseAddedToJourney: 'Kurs zum Lernpfad hinzugefügt.',
    courseRequired: 'Erforderlich',
    courseOptional: 'Optional',
    noJourneyCourses: 'Noch keine Kurse hinzugefügt.',
    settingsTitle: 'Einstellungen',
    settingsSubtitle: 'Standardwerte für neue Inhalte.',
    defaultsSection: 'Inhaltsstandards',
    maintenanceSection: 'Wartung',
    recalcStates: 'Kursstatus neu aufbauen',
    recalcStatesHint:
      'Berechnet jede Einschreibung aus Lektionsfortschritt und Testversuchen neu. Jederzeit unbedenklich.',
    recalcDone: '{count} Einschreibungen neu berechnet.',
    brandingSection: 'Branding',
    organisationName: 'Name der Organisation',
    defaultLocale: 'Standardsprache',
  },

  users: {
    title: 'Benutzer',
    subtitle: 'Verwalten Sie, wer Zugang hat und was er tun darf.',
    invite: 'Benutzer einladen',
    inviteTitle: 'Benutzer einladen',
    inviteSubtitle: 'Die Person erhält eine E-Mail mit einem Link zum Festlegen des Passworts.',
    inviteSent: 'Einladung an {email} gesendet.',
    inviteFailed: 'Die Einladung konnte nicht gesendet werden.',
    pendingInvitations: 'Offene Einladungen',
    revokeInvitation: 'Zurückziehen',
    invitationRevoked: 'Einladung zurückgezogen.',
    role: 'Rolle',
    roleName: {
      learner: 'Lernender',
      instructor: 'Dozent',
      admin: 'Administrator',
    },
    roleChanged: 'Rolle aktualisiert. Die Änderung wirkt mit der nächsten Anmeldung.',
    active: 'Aktiv',
    inactive: 'Deaktiviert',
    activate: 'Aktivieren',
    deactivate: 'Deaktivieren',
    activated: 'Benutzer aktiviert.',
    deactivated: 'Benutzer deaktiviert.',
    joined: 'Beigetreten',
    lastActive: 'Zuletzt aktiv',
    viewProgress: 'Fortschritt ansehen',
    progressTitle: 'Fortschritt von {name}',
    assignCourse: 'Kurs zuweisen',
    assignedLearners: 'Zugewiesene Lernende',
    assignmentsSaved: 'Zuweisungen gespeichert.',
    assignJourney: 'Lernpfad zuweisen',
    assigned: '{count} Lernenden zugewiesen.',
    unassign: 'Zuweisung entfernen',
    unassigned: 'Zuweisung entfernt.',
    dueDate: 'Fälligkeitsdatum',
    selectLearners: 'Lernende',
    noLearnersSelected: 'Wählen Sie mindestens eine Person.',
    empty: 'Keine Benutzer passen zu Ihren Filtern.',
    cannotChangeOwnRole: 'Sie können Ihre eigene Rolle nicht ändern.',
    cannotDeactivateSelf: 'Sie können Ihr eigenes Konto nicht deaktivieren.',
    groups: 'Gruppen',
    groupsUpdated: 'Gruppen aktualisiert.',
  },

  groups: {
    label: 'Gruppen',
    partner: 'Partner',
    developer: 'Entwickler',
    viewer: 'Betrachter',
  },

  reports: {
    title: 'Berichte',
    subtitle: 'Einschreibungen, Abschlüsse und Testergebnisse.',
    tabCourses: 'Kurse',
    tabLearners: 'Lernende',
    tabQuizzes: 'Tests',
    tabJourneys: 'Lernpfade',
    course: 'Kurs',
    enrollments: 'Einschreibungen',
    completed: 'Abgeschlossen',
    inProgress: 'In Bearbeitung',
    notStarted: 'Nicht begonnen',
    completionRate: 'Abschlussquote',
    averageProgress: 'Durchschnittlicher Fortschritt',
    quiz: 'Test',
    attempts: 'Versuche',
    learners: 'Lernende',
    passRate: 'Bestehensquote',
    averageScore: 'Durchschnittliches Ergebnis',
    passingScore: 'Bestehensgrenze',
    learnerName: 'Lernende',
    coursesCompleted: 'Abgeschlossene Kurse',
    points: 'Punkte',
    certificates: 'Zertifikate',
    exportCsv: 'CSV exportieren',
    empty: 'Für diesen Bericht liegen noch keine Daten vor.',
  },

  states: {
    loading: 'Wird geladen',
    loadingHint: 'Einen Moment…',
    errorTitle: 'Etwas ist schiefgelaufen',
    errorHint: 'Die Anfrage wurde nicht abgeschlossen. Sie können es erneut versuchen.',
    emptyTitle: 'Hier ist noch nichts',
    notFoundTitle: 'Seite nicht gefunden',
    notFoundHint: 'Die gesuchte Seite existiert nicht oder wurde verschoben.',
    forbiddenTitle: 'Kein Zugriff',
    forbiddenHint: 'Sie haben keine Berechtigung für diese Seite.',
    goHome: 'Zur Übersicht',
    offlineTitle: 'Sie sind offline',
    offlineHint:
      'Prüfen Sie Ihre Verbindung. Ihre Eingaben bleiben lokal erhalten, bis sie zurück ist.',
  },

  errors: {
    generic: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
    network: 'Der Server war nicht erreichbar. Prüfen Sie Ihre Verbindung.',
    unauthorized: 'Dafür müssen Sie angemeldet sein.',
    forbidden: 'Dazu haben Sie keine Berechtigung.',
    notFound: 'Wir konnten das Gesuchte nicht finden.',
    conflict: 'Das existiert bereits.',
    invalidCredentials: 'E-Mail und Passwort passen nicht zusammen.',
    invalidReybexCredentials:
      'Dieser Reybex-Benutzername und dieses Passwort passen nicht zusammen.',
    reybexEmailInUse:
      'Ein LMS-Konto verwendet diese E-Mail bereits. Melden Sie sich über die LMS-Konto-Option an.',
    reybexNotConfigured: 'Die Reybex-Anmeldung ist nicht konfiguriert.',
    reybexUnavailable: 'Reybex war nicht erreichbar. Versuchen Sie es gleich noch einmal.',
    reybexTenantNotAllowed: 'Dieses Reybex-Konto darf sich hier nicht anmelden.',
    passwordManagedByReybex: 'Dieses Passwort wird in Reybex verwaltet.',
    emailInUse: 'Mit dieser E-Mail existiert bereits ein Konto.',
    weakPassword: 'Wählen Sie ein längeres Passwort.',
    rateLimited: 'Zu viele Versuche. Warten Sie einen Moment und versuchen Sie es erneut.',
    slugTaken: 'Dieses URL-Kürzel wird bereits von einem anderen Kurs verwendet.',
    notEnrolled: 'Sie sind in diesem Kurs nicht eingeschrieben.',
    lessonsIncomplete: 'Schließen Sie zuerst die erforderlichen Lektionen ab.',
    maxAttempts: 'Sie haben alle Versuche für diesen Test genutzt.',
    quizNoQuestions: 'Dieser Test enthält noch keine Fragen.',
    attemptClosed: 'Dieser Versuch wurde bereits abgegeben.',
    selfEnrollClosed: 'Für diesen Kurs ist keine Selbsteinschreibung möglich.',
    lessonHasProgress:
      'Lernende haben Fortschritt in dieser Lektion, daher kann sie nur archiviert werden.',
    schemaMissing:
      'Das Datenbankschema ist noch nicht angewendet. Im Projektordner ausführen: npm run db:migrate',
  },

  validation: {
    required: 'Dieses Feld ist erforderlich',
    email: 'Geben Sie eine gültige E-Mail-Adresse ein',
    minLength: 'Verwenden Sie mindestens {min} Zeichen',
    maxLength: 'Verwenden Sie höchstens {max} Zeichen',
    passwordMin: 'Verwenden Sie mindestens 8 Zeichen',
    passwordMatch: 'Die Passwörter stimmen nicht überein',
    passwordNeeds: 'Noch erforderlich: {items}.',
    passwordNeed: {
      length: 'Mindestens 9 Zeichen',
      upper: 'Großbuchstaben ergänzen',
      lower: 'Kleinbuchstaben ergänzen',
      digit: 'Eine Ziffer ergänzen',
      special: 'Ein Sonderzeichen ergänzen',
    },
    number: 'Geben Sie eine Zahl ein',
    min: 'Muss mindestens {min} sein',
    max: 'Darf höchstens {max} sein',
    url: 'Geben Sie eine gültige URL ein',
    slug: 'Nur Kleinbuchstaben, Zahlen und Bindestriche',
    fileTooLarge: 'Diese Datei ist größer als das Limit von {max}',
    fileType: 'Dieser Dateityp wird nicht unterstützt',
    atLeastOne: 'Wählen Sie mindestens eine Option',
    atLeastOneCorrect: 'Markieren Sie mindestens eine Option als richtig',
    atLeastTwoOptions: 'Fügen Sie mindestens zwei Antwortoptionen hinzu',
    positiveInteger: 'Geben Sie eine ganze Zahl größer als null ein',
  },

  rewards: {
    continue: 'Weiter',
    kindLesson: 'Lektion abgeschlossen',
    kindQuiz: 'Test bestanden',
    kindCourse: 'Kurs abgeschlossen',
    kindCertificate: 'Zertifikat erhalten',
    kindJourney: 'Lernpfad abgeschlossen',
    lessonTitle: 'Gut gemacht',
    lessonBody: 'Sie haben „{title}“ abgeschlossen.',
    quizTitle: 'Bestanden',
    quizBody: 'Diese Punktzahl öffnet den nächsten Schritt.',
    quizBodyCertificate: 'Bestehensgrenze erreicht — Ihr Zertifikat ist bereit.',
    quizRetryHint: 'Keine Feier — wiederholen Sie die Lektion und versuchen Sie es erneut.',
    courseTitle: 'Kurs abgeschlossen',
    courseBody: 'Sie haben {title} abgeschlossen.',
    certificateTitle: 'Zertifikat freigeschaltet',
    certificateBody: 'Sie haben ein Zertifikat für {title} erhalten.',
    viewCertificate: 'Zertifikat ansehen',
    journeyTitle: 'Lernpfad abgeschlossen',
    journeyBody: 'Sie haben den Pfad „{title}“ abgeschlossen.',
    score: 'Ergebnis: {score}',
  },

  setup: {
    title: 'Administrator einrichten',
    subtitle: 'Der erste Administrator kann Kurse für die Organisation anlegen.',
    body: 'Es gibt noch keinen Administrator. Mit dieser Rolle können Sie Kurse erstellen und veröffentlichen. Spätere Registrierungen bleiben Lernende, bis Sie sie einladen.',
    claim: 'Administrator werden',
    claimed: 'Sie sind jetzt Administrator.',
    alreadyAdmin:
      'Sie haben bereits Mitarbeiterzugang. Öffnen Sie das Admin-Dashboard, um Kurse anzulegen.',
    unavailable:
      'Es gibt bereits einen Administrator. Bitten Sie um eine Einladung, wenn Sie Zugang brauchen.',
  },

  landing: {
    metaTitle: 'Reybex Academy',
    product: 'Academy',
    navJourneys: 'Lernpfade',
    navHow: 'So funktioniert’s',
    navCerts: 'Zertifikate',
    navAudience: 'Für wen',
    themeToLight: 'Zum hellen Design wechseln',
    themeToDark: 'Zum dunklen Design wechseln',
    signIn: 'Anmelden',
    signUp: 'Konto erstellen',
    openCampus: 'Campus öffnen',
    eyebrow: 'Lernplattform für das reybex Cloud ERP',
    headlineLead: 'Das ERP beherrschen,',
    headlineAccent: 'das das Geschäft trägt.',
    sub: 'Strukturierte Lernpfade für Partner, Entwickler und Anwender — von Lager bis Finanzbuchhaltung. Lektionen abschließen, Prüfung bestehen, Zertifikat sichern. Öffentlich prüfbar.',
    ctaStart: 'Jetzt lernen',
    ctaExplore: 'Lernpfade ansehen',
    statLevels: 'Lernstufen',
    statLevelsValue: 'L0–L4',
    statAudiences: 'Zielgruppen',
    statAudiencesValue: '3 Rollen',
    statLangs: 'Sprachen',
    statLangsValue: 'DE · EN',
    statProof: 'Nachweis',
    statProofValue: 'Zertifikate',
    audiencesTitle: 'Gebaut für die Menschen, die reybex bewegen',
    audiencesSub:
      'Partner, Developer und Viewer bekommen jeweils den Pfad, der zu ihrer Arbeit im Cloud-ERP passt — kein generischer Katalog.',
    audiencePartnerTitle: 'Partner',
    audiencePartnerBody:
      'Enablement für Implementierungspartner: Prozesse, Konfiguration und wie das Kundenteam geschult wird.',
    audienceDeveloperTitle: 'Developer',
    audienceDeveloperBody:
      'Konfigurationstiefe, APIs und der technische Weg von der Einrichtung bis zur Erweiterung — getrennt vom Endanwender-Training.',
    audienceViewerTitle: 'Viewer',
    audienceViewerBody:
      'Der Alltag in Verkauf, Lager, Einkauf und Finanzen. Nur das, was die Rolle zum Arbeiten braucht.',
    levelsEyebrow: 'Curriculum',
    levelsTitle: 'Vom ersten Login bis zur Zertifizierung',
    levelsSub:
      'Fünf Stufen, dieselbe Sprache wie die reybex-Organisation. Ein Kurs zählt erst, wenn die Prüfung bestanden ist.',
    level0: 'Basis',
    level0Body: 'Orientierung im Cloud-ERP. Navigation, Stammdaten, der Common Core.',
    level1: 'Fachbereich',
    level1Body: 'Verkauf, Lager, Einkauf, Finanzen — die Arbeit der Spezialisten.',
    level2: 'Konfiguration',
    level2Body: 'Wie das System für ein echtes Unternehmen eingerichtet wird.',
    level3: 'Developer',
    level3Body: 'Integrationen, API-first und das Erweitern von reybex.',
    level4: 'Praxis & Zertifizierung',
    level4Body: 'Anwenden, Prüfung bestehen, Zertifikat mitnehmen.',
    howTitle: 'Erst die Prüfung. Dann das Zertifikat.',
    howSub:
      'Ein Kurs ist erst fertig, wenn die Pflichtlektionen erledigt und die Prüfung bestanden sind. Punkte und Zertifikate folgen automatisch — nie per Handschalter.',
    how1Title: 'Lernpfad wählen',
    how1Body:
      'Sequenzielle Pfade öffnen den nächsten Kurs nach dem Abschluss. Flexible Pfade lassen die Reihenfolge offen.',
    how2Title: 'Im Player lernen',
    how2Body:
      'Video- und Textlektionen. Fortschritt wird gespeichert. Pflichtinhalte müssen abgeschlossen werden.',
    how3Title: 'Prüfung bestehen',
    how3Body:
      'Bewertung auf dem Server. Zeitlimit und Versuchslimits gelten. Richtige Antworten bleiben bis zur Abgabe verborgen.',
    how4Title: 'Zertifikat sichern',
    how4Body: 'Eine eindeutige Nummer, ein öffentlicher Prüflink und ein PDF zum Teilen.',
    journeysTitle: 'Lernpfade',
    journeysSub:
      'Rollenbasierte Wege durch die reybex-Module — Verkauf, Lager, Produktion, Finanzen und mehr.',
    journeysCta: 'Alle Lernpfade',
    featuresTitle: 'Alles, was eine Academy braucht. Nichts darüber hinaus.',
    featureJourneysTitle: 'Lernpfade',
    featureJourneysBody:
      'Sequenziell oder flexibel. Pflichtkurse. Fortschritt, der sich immer aus Fakten neu berechnet.',
    featureQuizTitle: 'Ehrliche Prüfungen',
    featureQuizBody: 'Bewertung auf dem Server. Keine richtigen Antworten im Player.',
    featureCertsTitle: 'Prüfbare Zertifikate',
    featureCertsBody:
      'Jeder kann die öffentliche Prüseite öffnen. Die Autorität liegt im Datensatz, nicht im PDF.',
    featureGroupsTitle: 'Partner · Developer · Viewer',
    featureGroupsBody: 'Inhalte gelten nur für die Gruppe, die sie sehen soll.',
    featureReportsTitle: 'Berichte für Admins',
    featureReportsBody: 'Abschlüsse, Bestehensquote, überfällige Zuweisungen — in einer Ansicht.',
    featureI18nTitle: 'Deutsch, Englisch',
    featureI18nBody: 'Die Academy spricht die Sprachen des reybex-Marktes.',
    ctaTitle: 'Bereit für das nächste Modul?',
    ctaBody: 'Konto anlegen oder anmelden. Dein Pfad, deine Prüfung, dein Zertifikat.',
    footerTagline: 'Der Campus für das reybex Cloud ERP.',
    footerCourses: 'Kurse',
    footerJourneys: 'Lernpfade',
    footerVerify: 'Zertifikate',
    footerRights: '© {year} EDIT Systems GmbH. Reybex Academy.',
    orbitSales: 'Verkauf',
    orbitWarehouse: 'Lager',
    orbitProduction: 'Produktion',
    orbitFinance: 'Finanzen',
    orbitCrm: 'CRM',
    orbitShop: 'Commerce',
    menuOpen: 'Menü öffnen',
    menuClose: 'Menü schließen',
    mockChrome: 'Reybex Academy · Kursplayer',
    mockPath: 'Dieser Kurs',
    mockLesson1: 'Den Arbeitsbereich verstehen',
    mockLesson2: 'Stammdaten, die sauber bleiben müssen',
    mockLesson3: 'Ein Kundenauftrag, Ende zu Ende',
    mockQuiz: 'Abschlussprüfung',
    mockNow: 'Ein Kundenauftrag, Ende zu Ende',
    mockNowMeta: 'Video · Pflicht · 12 Min.',
    mockRequired: 'Pflicht',
    mockCertEyebrow: 'Zertifikat',
    mockCertBody: 'Wird nach bestandener Prüfung ausgestellt. Öffentlich prüfbar.',
  },

  categories: {
    'track-administration': 'Administration',
    'track-artikel-pim': 'Artikel & PIM',
    'track-crm': 'CRM',
    'track-allgemein': 'Allgemein',
    'track-continuous': 'Continuous',
    'track-e-commerce': 'E-Commerce',
    'track-edi': 'EDI',
    'track-einkauf': 'Einkauf',
    'track-entwicklung': 'Entwicklung',
    'track-finanzen': 'Finanzen',
    'track-hr': 'HR',
    'track-kasse-pos': 'Kasse/POS',
    'track-lager': 'Lager',
    'track-mobile-lager-app': 'Mobile Lager-App',
    'track-partner-enablement': 'Partner-Enablement',
    'track-praxis': 'Praxis',
    'track-produktion': 'Produktion',
    'track-projekte-service': 'Projekte & Service',
    'track-qualit-t': 'Qualität',
    'track-verkauf': 'Verkauf',
    'track-versand': 'Versand',
    'track-zertifizierung': 'Zertifizierung',
    'ornek-depo-lojistik': 'Lager und Logistik',
    'ornek-satis-faturalama': 'Verkauf und Rechnungsstellung',
  },
}
